module.exports = __webpack_public_path__ + "9c4c92aed1af538d4578162f445ca253.png";